/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationIdDto
 */
export interface OrganizationIdDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdDto
     */
    id: string;
}

/**
 * Check if a given object implements the OrganizationIdDto interface.
 */
export function instanceOfOrganizationIdDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function OrganizationIdDtoFromJSON(json: any): OrganizationIdDto {
    return OrganizationIdDtoFromJSONTyped(json, false);
}

export function OrganizationIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationIdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function OrganizationIdDtoToJSON(value?: OrganizationIdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

